import {
    PricingTier,
    CurrencyISOCode,
    PriceCalculationResponse,
    PricingTierPrice,
    BreakdownPriceTier,
    PricingStrategy
} from "../../constants";
import { getLocalUnitPrice } from "../get-local-unit-price";

export default function (
    numUnits: number,
    matchingTierIdx: number,
    tiers: PricingTier[],
    currencyISOCode: CurrencyISOCode
): PriceCalculationResponse {
    let totalPrice = 0;
    let price = 0;
    const breakdown: BreakdownPriceTier[] = [];

    const getUnitPrice = (prices: PricingTierPrice[]) =>
        getLocalUnitPrice(currencyISOCode, prices);

    // if no matching tier then default to highest (last) tier
    if (matchingTierIdx === -1) {
        matchingTierIdx = tiers.length - 1;
    }

    let idx = 0;
    for (const tier of tiers) {
        const { unitLimitLower, unitLimitUpper } = tier;
        const adjUnitLimitLower = Math.max((unitLimitLower || 0) - 1, 0);

        // the upper unit limit can't be undefined so we can just set it to
        // one million units as an upper bound
        const adjUnitLimitUpper = unitLimitUpper || 1000000;
        const unitsInTier =
            idx === matchingTierIdx
                ? numUnits - adjUnitLimitLower
                : adjUnitLimitUpper - adjUnitLimitLower;

        if (tier.pricingStrategy === PricingStrategy.FIXED_COST) {
            price = getUnitPrice(tier.prices.slice());
        } else {
            const finalTier = tiers[
                Math.min(idx, tiers.length - 1)
            ] as PricingTier;
            price = getUnitPrice(finalTier.prices.slice());
        }

        const totalPriceForTier =
            tier.pricingStrategy === PricingStrategy.FIXED_COST
                ? price
                : unitsInTier * price;
        totalPrice += totalPriceForTier;

        breakdown.push({
            unitsInTier,
            unitsAvailableInTier: adjUnitLimitUpper - unitsInTier,

            unitLimitLower: adjUnitLimitLower || 1,
            unitLimitUpper: adjUnitLimitUpper,

            totalPriceForTier,
            avgPerUnitPriceForTier: price
        });

        if (++idx > matchingTierIdx) {
            break;
        }
    }

    const avgPerUnitPrice = totalPrice / numUnits;

    return {
        totalPrice,
        avgPerUnitPrice,

        hasFlatRateFirstTier:
            tiers[0]?.pricingStrategy === PricingStrategy.FIXED_COST,

        breakdown
    };
}
